// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"bff052ce","309":"c723e0f3","351":"7cf12130","397":"7d665351","413":"bb794746","474":"4fe5831c","500":"701b33b6","555":"764c98e8","631":"095df062","666":"9f3ed2b3","913":"7ee7b921","960":"87b24a4a"}[chunkId] + ".chunk.css";
};